export default __webpack_public_path__ + "static/media/second-slide-large.ab204a66.jpg";